export class entiteAdd{
    numEntite!:number;
    num_pere!: number;
    libelle!: string;
    adresse1!: string;
    adresse2!: string;
    adresse3!: string;
    code_postal: string='';
    ville!: string;
    type!: string;
    ext!:0;
    tel!: string;
    web!:string;
    user!: string;
    axe!: string;
    dc!: string;
    dm!: string;
    formeJuridique!: string;
    statut!:number;
    // constructor(num_pere: string,  libelle: string, adresse1: string, adresse2: string, adresse3: string, code_postal: string, ville: string, ext: number, tel: string,
    //   web: string,user: string,axe: string,formeJuridique: string)  { }

  }